import { render, staticRenderFns } from "./WorkspaceRoleMenu.vue?vue&type=template&id=75e78c11&scoped=true"
import script from "./WorkspaceRoleMenu.vue?vue&type=script&lang=js"
export * from "./WorkspaceRoleMenu.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceRoleMenu.vue?vue&type=style&index=0&id=75e78c11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e78c11",
  null
  
)

export default component.exports